import { render } from "./SurveyQuestionGroup.vue?vue&type=template&id=258312fb&lang=pug"
import script from "./SurveyQuestionGroup.vue?vue&type=script&lang=js"
export * from "./SurveyQuestionGroup.vue?vue&type=script&lang=js"

import exportComponent from "/builds/mfar.technology/events/events-platform/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__